// Primary = solid Bright Blue, white text. Secondary = powder-blue bg,
// navy text. No amber/gold buttons — per BRAND_TOKENS.md §4.
export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  as: As = 'button',
  className = '',
  ...rest
}) {
  const cls = `aq-btn aq-btn--${variant} aq-btn--${size} ${className}`.trim();
  return (
    <As className={cls} {...rest}>
      {children}
    </As>
  );
}
